<template>
  <section>
    <router-link
      :to="{name: 'Shelter'}">
      Back
    </router-link>
    <h3>Add Shelter</h3>
    <b-field label="Disaster Name">
      <b-select placeholder="Select disaster" v-model="form.disasterName">
        <option
          v-for="i in disasterNames"
          :key="i._id"
          value="i.code">
          {{i.year}} - {{i.name}}
        </option>
      </b-select>
    </b-field>
    <b-field label="Code">
      <b-input v-model="form.code" placeholder="ex: SHEL-233"/>
    </b-field>
    <b-field label="Name">
      <b-input v-model="form.name" placeholder="Shelter name"/>
    </b-field>
    <b-field label="Status">
      <b-select placeholder="Select status" v-model="form.status">
        <option value="ACTIVE">
          Active
        </option>
        <option value="INACTIVE">
          Inactive
        </option>
      </b-select>
    </b-field>
    <b-field label="Address">
      <b-input v-model="form.address" placeholder="Shelter address"/>
    </b-field>
    <b-field label="Location">
      <span>
        <b-input v-model="form.location" placeholder="Coordinate"/><br/>
        <b-button @click="showSelectLocation">
          <b-icon icon="map"/>
          Select from map
        </b-button>
      </span>
    </b-field>
    <b-field label="Phone">
      <b-input type="tel" v-model="form.phone" placeholder="+62 xxx xxxx xxxx"/>
    </b-field>
    <b-field label="PIC">
      <b-input v-model="form.pic" placeholder="PIC name"/>
    </b-field>
    <b-button
      @click="submit">
      Save
    </b-button>
    <b-modal :active.sync="visibleMapModal"
      :width="640" scroll="keep">
      <SelectLocation
        :marker="marker"
        :center="map.center"
        :zoom="map.zoom"
        @selectLocation="setLocation"/>
    </b-modal>
  </section>
</template>

<style lang="scss" scoped>
/deep/ .modal .modal-content {
  height: 90vh;
}
</style>

<script>
import {latLng} from 'leaflet'
import {mapActions, mapGetters} from 'vuex'
import SelectLocation from "@/components/SelectLocation"

const DEFAULT_CENTER = latLng(-0.599094, 117.504444)

export default {
  name: 'CreateDisasterName',
  components: {
    SelectLocation
  },
  data () {
    return {
      form: {
        disasterName: '',
        code: '',
        name: '',
        status: '',
        address: '',
        location: '',
        phone: '',
        pic: ''
      },
      marker: null,
      visibleMapModal: false,
      map: {
        center: DEFAULT_CENTER,
        zoom: 5
      }
    }
  },
  created () {
    this.init()
  },
  computed: {
    ...mapGetters('DisasterName', {
      disasterNames: 'names'
    })
  },
  methods: {
    ...mapActions('Shelter',['create']),
    ...mapActions('DisasterName',{
      fetchDisasters: 'fetch'
    }),
    init () {
      this.fetchDisasters()
    },
    submit () {
      this.create(this.form)
        .then(() => {
          this.$router.replace({name: 'Shelter'})
        })
        .catch(() => {
          alert('Create failed')
        })
    },
    showSelectLocation () {
      this.visibleMapModal = true
    },
    setLocation (loc) {
      this.form.location = loc.lat + ',' + loc.lng
      this.visibleMapModal = false
    }
  },
  watch: {
    'form.location': function (v) {
      this.marker = latLng(...v.split(','))
    }
  }
}
</script>
